import { types } from 'mobx-state-tree';

const SchemaType = {
  AGGREGATE_RATING: 'AggregateRating',
  BRAND: 'Brand',
  BREADCRUMB_LIST: 'BreadcrumbList',
  COLLECTION_PAGE: 'CollectionPage',
  DEFINED_REGION: 'DefinedRegion',
  ITEM_LIST: 'ItemList',
  ITEM_PAGE: 'ItemPage',
  LIST_ITEM: 'ListItem',
  MONETARY_AMOUNT: 'MonetaryAmount',
  OFFER: 'Offer',
  OFFER_SHIPPING_DETAILS: 'OfferShippingDetails',
  ORGANIZATION: 'Organization',
  PERSON: 'Person',
  PRODUCT: 'Product',
  PRODUCT_GROUP: 'ProductGroup',
  QUANTITATIVE_VALUE: 'QuantitativeValue',
  RATING: 'Rating',
  REVIEW: 'Review',
  SEARCH_ACTION: 'SearchAction',
  SEARCH_RESULTS_PAGE: 'SearchResultsPage',
  SHIPPING_DELIVERY_TIME: 'ShippingDeliveryTime',
  WEB_PAGE: 'WebPage',
};

export default SchemaType;

export const SchemaTypeType = types.enumeration(
  'SchemaType',
  Object.values(SchemaType)
);
